"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.declineWord = exports.numWord = void 0;
const numWord = (value, words) => {
    const val = Math.abs(value) % 100;
    const num = val % 10;
    if (val > 10 && val < 20)
        return words[2];
    if (num > 1 && num < 5)
        return words[1];
    if (num == 1)
        return words[0];
    return words[2];
};
exports.numWord = numWord;
const pluralRules = new Intl.PluralRules('ru');
const declineWord = (number, words) => {
    return `${number} ${words[pluralRules.select(number)]}`;
};
exports.declineWord = declineWord;
